import { Navigate, Outlet, useLocation } from "react-router-dom";
import useIsAuthenticated from "@hooks/useIsAuthenticated";
import { PATHS_AUTH_V2 } from "@helpers/constantes";

/**
 * Rutas del wizard v2 que necesitan sesión. Mientras se consulta la sesión no se dibuja nada; sin
 * sesión se manda al login v2. Quedan fuera (públicas) el cotizador, crear cuenta y el registro de
 * datos: este último crea la cuenta e inicia la sesión al enviarse, así que antes no hay sesión.
 */
const ProtectRouteAuthenticated = () => {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated === null) return null;
  if (!isAuthenticated) return <Navigate to={PATHS_AUTH_V2.login.path} replace state={{ from: location }} />;

  return <Outlet />;
};

export default ProtectRouteAuthenticated;
